<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='wip-plan-wrap'>
      <dx-data-grid ref='refWipPlan'
        :data-source='planInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="품번"
        @toolbar-preparing='onToolbarPreparing'
        @row-updated='onRowUpdatedPlan'
        @key-down="onKeyDown"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="다공정주간계획"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxKeyboardNavigation
          :edit-on-key-press="true"
          enter-key-action="moveFocus"
          enter-key-direction="row"
        />
        <DxEditing
          :allow-deleting="false"
          :allow-updating="isPlanning"
          :allow-adding="false"
          :use-icons="true"
          mode='batch'
        >
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn v-if="$store.getters.getGroupName !== null"
          :caption="$store.getters.getGroupName"
          data-field="차종"
          width='70'
        >
        </DxColumn>
        <DxColumn
          caption="품번"
          data-field="품번"
          width='120'
        >
        </DxColumn>
        <DxColumn
          caption="품명"
          data-field="품명"
          width='150'
        >
        </DxColumn>
        <DxColumn
          sort-order='asc'
          caption="라인명"
          data-field="라인코드"
          width='120'
        >
          <DxLookup
            :data-source="lineLookup"
            display-expr="라인명"
            value-expr="라인코드"
          />
        </DxColumn>
        <DxColumn
          caption="공정유형"
          data-field="공정유형"
          width='80'
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          format ='#,##0'
          caption="합계"
          dataType="number"
          :calculateCellValue='sumPlan'
        >
        </DxColumn>
        <DxColumn
          caption="주간 생산계획"
          alignment='center'
        >
          <DxColumn v-for='(item, index)  in  dateArray' :key="index"
            :caption = item.caption
            :data-field = item.dataField
            :data-type = item.dataType
            :format = item.format
            :allow-sorting="false"
          />
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="합계"
            summary-type="sum"
            display-format="{0}"
          />
          <DxTotalItem v-for='(item, index)  in  dateArray' :key="index+50"
            value-format='#,##0'
            :column = item.dataField
            summary-type="sum"
            display-format="{0}"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <div class='mrp-wrap'>
      <dx-data-grid ref='refMrp'
        :data-source='mrpDataSource'
        :show-borders = 'true' :showRowLines = 'true' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'false'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='pivotHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="품번"
        @toolbar-preparing='onToolbarPreparingMrp'
        row-template="dataRowTemplate"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="mrpTitle"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
          width='160'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
          width='160'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
          width=80
        >
          <DxLookup
            :data-source="productypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
          :fixed="false"
          :width=70
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
          width='54'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          format ='#,##0'
          caption="소요합계"
          data-field="합계"
          dataType="number"
          width=60
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          format ='#,##0'
          caption="가용재고"
          data-field="가용재고"
          dataType="number"
          width=60
        >
        </DxColumn>
        <DxColumn
          caption="창고재고"
          alignment='center'
        >
          <DxColumn
            caption="재공재고"
            alignment='center'
          />
        </DxColumn>

        <DxColumn
          :caption="mrpTitle"
          alignment='center'
        >
          <DxColumn v-for='(item, index)  in  dateArrayMrp' :key="index+100"
            :caption = item.caption
            :data-field = item.dataField
            :data-type = item.dataType
            :format = item.format
            :allow-sorting="false"
          />
        </DxColumn>
        <dx-paging :enabled="false"/>
        <dx-scrolling  mode='virtual' showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
          <template #dataRowTemplate="{ data: rowInfo }">
          <tbody :class="{'dx-row-toggle': rowInfo.rowIndex % 2}"
            class="week-plan "
          >
            <tr class="row main-row">
              <td rowspan="2" style='white-space:nowrap; text-overflow:ellipsis; overflow:hidden'>{{ rowInfo.data.품번 }}</td>
              <td rowspan="2" style='white-space:nowrap; text-overflow:ellipsis; overflow:hidden'>{{ rowInfo.data.품명 }}</td>
              <td rowspan="2">{{ getText(rowInfo.data.품목유형,'품목') }}</td>
              <td rowspan="2">{{ getText(rowInfo.data.공정유형, '공정') }}</td>
              <td rowspan="2">{{ getText(rowInfo.data.단위, '단위') }}</td>
              <td rowspan="2" class='row-number-span'>{{ rowInfo.data.합계 | comma}}</td>
              <td rowspan="2" class='row-number-span' style='color:blue;'>{{ rowInfo.data.현재고+rowInfo.data.현재공 | comma}}</td>
              <td class='row-number'  style='color:green;'>{{ rowInfo.data.현재고 | comma}}</td>
              <td class='row-number' v-for='(item, index)  in  dateArrayMrp' :key="index+200">
                {{ rowInfo.data[item.dataField] }}
              </td>
            </tr>
            <tr class="row stock-row">
              <td class='row-number' style='color:green;'>{{ rowInfo.data.현재공 | comma}}</td>
              <td class='row-number' :class="{'dx-row-minus': rowInfo.data[item.stockField] < 0}"
                v-for='(item, index)  in  dateArrayMrp' :key="index+300">
                {{ rowInfo.data[item.stockField] | comma}}
              </td>
            </tr>
          </tbody>
          </template>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxSummary, DxKeyboardNavigation,
  DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'
import axios from 'axios'
import HttpService from '../../share/service/HttpService'

export default {
  name: 'weekPlan',
  data: function () {
    return {
      isLoading: false,
      gridHeight: null,
      thisSundayDate: null,
      today: null,
      thisWeekendDate: null,
      weekDays: 14,
      nextWeekendDate: null,
      dateArray: [],
      planInfoList: [],
      updateMode: false,
      isUpdating: false,
      itemTypeLookup: null,
      isAllList: false,
      thisWeekPlan: null,
      productInfo: null,
      lineLookup: null,
      // mrp pivot
      dateArrayMrp: [],
      mrpDataSource: null,
      mrpTitle: null,
      pivotHeight: 300,
      productypeLookup: null,
      showMrpBtn: null,
      unitLookup: null,
      processingTypeLookup: null
    }
  },
  props: {
    isPlanning: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxKeyboardNavigation
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }

    this.today = AppLib.getToday()
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.refreshLineInfo()
    this.refreshWeekPlan()
  },
  mounted () {
    if (this.isPlanning) {
      this.$snotify.error('계획 등록/수정 시 품목 소요량은 재산출 됩니다.')
    }
  },
  updated () {
  },
  beforeDestroy: function () {
  },
  computed: {

  },
  methods: {
    getText (code, type) {
      if (type === '품목') return this.$_.findWhere(this.productypeLookup, { 코드: code }).코드명
      else if (type === '공정') {
        const temp = this.$_.findWhere(this.processingTypeLookup, { 코드: code })
        if (temp === undefined) {
          return null
        }
        return temp.코드명
      } else if (type === '단위') return this.$_.findWhere(this.unitLookup, { 코드: code }).코드명
    },
    calcNextWeekendDay (day) {
      this.nextWeekendDate = AppLib.calcDateFromToday(13)
    },
    initDateArray () {
      this.dateArray = []
      this.calcNextWeekendDay()
      for (let j = 0; j < this.weekDays; j++) {
        let day = AppLib.calcDateFromFormat(this.today, j)
        day = `${day.substring(5, 7)}/${day.substring(8, 10)}`
        let dateTemp = {
          caption: day,
          dataField: day,
          format: '#,##0',
          dataType: 'number'
        }
        this.dateArray.push(dateTemp)
      }
    },
    makeWeekModel (planInfo, product) { // planInfo ={생산일자 품번 품명 수량}
      console.log(product)
      this.planInfoList = []
      this.initDateArray()
      if (planInfo.length === 0) {
        for (let i = 0; i < product.length; i++) {
          let temp = {
            품번: product[i].품번,
            품명: product[i].품명,
            공정유형: product[i].공정유형,
            라인코드: product[i].라인코드,
            차종: product[i].차종
          }
          for (let j = 0; j < this.weekDays; j++) {
            temp.생산일자 = AppLib.calcDateFromFormat(this.today, j)
            let key = `${temp.생산일자.substring(5, 7)}/${temp.생산일자.substring(8, 10)}`
            temp[key] = null
          }
          this.planInfoList.push(temp)
        }
        return
      }
      if (this.isAllList === false) {
        for (let i = 0; i < planInfo.length; i++) {
          if (this.$_.findIndex(this.planInfoList, { 품번: planInfo[i].품번 }) >= 0) continue
          let where = this.$_.findWhere(product, { 품번: planInfo[i].품번 })
          let temp = {
            품번: planInfo[i].품번,
            품명: planInfo[i].품명,
            공정유형: where.공정유형,
            라인코드: where.라인코드,
            차종: where.차종
          }
          for (let j = 0; j < this.weekDays; j++) {
            temp.생산일자 = AppLib.calcDateFromFormat(this.today, j)
            let timeStamp = AppLib.getTimestampFromString(`${temp.생산일자} 00:00:00`)
            let key = `${temp.생산일자.substring(5, 7)}/${temp.생산일자.substring(8, 10)}`
            let where = this.$_.findWhere(planInfo, { 생산일자: timeStamp, 품번: temp.품번 })
            if (where === undefined) {
              where = this.$_.findWhere(planInfo, { 생산일자: temp.생산일자, 품번: temp.품번 })
            }
            if (where === undefined) {
              temp[key] = null
            } else {
              temp[key] = where.수량
            }
          }
          this.planInfoList.push(temp)
          console.log(temp)
        }
      } else {
        for (let i = 0; i < product.length; i++) {
          let temp = {
            품번: product[i].품번,
            품명: product[i].품명,
            공정유형: product[i].공정유형,
            라인명: product[i].라인명,
            차종: product[i].차종
          }
          for (let j = 0; j < this.weekDays; j++) {
            temp.생산일자 = AppLib.calcDateFromFormat(this.today, j)
            let timeStamp = AppLib.getTimestampFromString(`${temp.생산일자} 00:00:00`)
            let key = `${temp.생산일자.substring(5, 7)}/${temp.생산일자.substring(8, 10)}`
            let where = this.$_.findWhere(planInfo, { 생산일자: timeStamp, 품번: product[i].품번 })
            if (where === undefined) {
              where = this.$_.findWhere(planInfo, { 생산일자: temp.생산일자, 품번: product[i].품번 })
            }
            if (where === undefined) {
              temp[key] = null
            } else {
              temp[key] = where.수량
            }
          }
          this.planInfoList.push(temp)
        }
      }
    },
    onKeyDown (e) {
      if (e.event.ctrlKey && e.event.key === 's') {
        // // // console.log('Ctrl + s was pressed')
        this.$refs.refWipPlan.instance.saveEditData()
      }
    },
    onRowUpdatedPlan (row) {
      if (this.isUpdating === true) return
      this.isUpdating = true
      this.savePlan()
    },
    async savePlan () {
      let planArray = []
      for (let j = 0; j < this.weekDays; j++) {
        let day = AppLib.calcDateFromFormat(this.today, j)
        let key = `${day.substring(5, 7)}/${day.substring(8, 10)}`
        for (let i = 0; i < this.planInfoList.length; i++) {
          let plan = this.planInfoList[i] // 제품계획
          if (plan[key] !== null) {
            let temp = {
              생산일자: day,
              품번: plan.품번,
              품명: plan.품명,
              수량: plan[key],
              품목유형: ConstDef.다공정품,
              createid: this.userInfo.userId,
              updateid: this.userInfo.userId
            }
            planArray.push(temp)
          }
        }
      }

      let param = {
        startDate: this.today,
        endDate: this.nextWeekendDate,
        품목유형: ConstDef.다공정품
      }

      let procResult = false
      this.isUpdating = true
      this.isLoading = true
      await this.$_sp.runUpdateProc('spDeleteWeekPlanByDateAndPtype', [param])
        .then((data) => {
          procResult = true
        })
        .catch(error => {
          this.isLoading = false
          this.isUpdating = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })

      if (procResult === false) {
        this.isLoading = false
        return procResult
      }
      procResult = false
      await this.$_sp.runInsertSqlProc('주간생산계획', null, planArray)
        .then((data) => {
          this.isUpdating = false
          procResult = true
          this.isLoading = false
          // this.reCalcMrp()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      return procResult
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>금일 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.today,
            type: 'date',
            disabled: true,
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
            }
          }
        },
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            hint: '자재 소요량 보기',
            icon: 'indent',
            text: '소요량보기',
            type: 'success',
            focusStateEnabled: false,
            disabled: false,
            onInitialized: (args) => {
              this.showMrpBtn = args.component
            },
            onClick: (args) => {
              const display = this.$Q('.mrp-wrap').css('display')
              if (display === 'none') {
                this.showMrpList()
              } else {
                this.hideMrpList()
              }
            }
          }
        },
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            hint: '자재 소요량 산출',
            icon: 'decreaseindent',
            text: '소요량산출',
            type: 'danger',
            focusStateEnabled: false,
            onClick: (args) => {
              this.saveMrp()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxCheckBox',
          options: {
            value: this.isAllList,
            text: '전품목 표시 ',
            onValueChanged: (args) => {
              this.isAllList = args.value
              if (this.thisWeekPlan.length > 0) {
                this.makeWeekModel(this.thisWeekPlan, this.productInfo)
              }
            }
          }
        }
      )
    },
    refreshLineInfo () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', null)
        .then(data => {
          this.lineLookup = this.$_sp.MakeModel(data)
        })
    },
    refreshWeekPlan () {
      let param = {
        fromDate: this.today,
        goodsType: ConstDef.다공정품
      }
      const weekPLan = this.$_sp.runNoEncodeFindProc('spFindAll2WeekPlan', param)
      const product = this.$_sp.runNoEncodeFindProc('spFindAllProductByFirstWip', {})
      this.isLoading = true
      axios.all([weekPLan, product])
        .then(axios.spread((...reponse) => {
          this.isLoading = false
          this.gridHeight = (screen.height - 250) * 0.95
          this.pivotHeight = this.gridHeight * 0.7
          this.thisWeekPlan = this.$_sp.MakeModel(reponse[0])
          this.productInfo = this.$_sp.MakeModel(reponse[1])
          this.makeWeekModel(this.thisWeekPlan, this.productInfo)

          this.refreshMrp(this.today)
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    saveMrp () {
      this.isLoading = true
      let param = {
        title: ConstDef.WEEK_PLAN_WIP_KEY,
        fromDate: this.today,
        days: this.weekDays,
        품목유형: ConstDef.다공정품,
        planType: 'WEEK'
      }

      HttpService.reqPostBody(this.$_sp.makeParamModel(param), '/saveMrpByPcode')
        .then((data) => {
          // this.$snotify.info('월계획 자재소요량을 조회하고 있습니다.', { timeout: 1000 })
          this.refreshMrp(this.today)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    sumPlan (e) {
      let sum = 0
      for (let i = 0; i < this.weekDays; i++) {
        let day = AppLib.calcDateFromFormat(this.today, i)
        let key = `${day.substring(5, 7)}/${day.substring(8, 10)}`
        sum += e[key]
      }
      return sum
    },
    //* ***************** MRP Pivot *************************** */
    showMrpList () {
      if (this.showMrpBtn !== null) this.showMrpBtn.option({ text: '소요량닫기' })
      this.$Q('.mrp-wrap').show()
      this.pivotHeight = this.gridHeight * 0.7
      this.gridHeight -= this.pivotHeight
    },
    hideMrpList () {
      if (this.showMrpBtn !== null) this.showMrpBtn.option({ text: '소요량보기' })
      this.$Q('.mrp-wrap').hide()
      this.gridHeight = (screen.height - 250) * 0.95
    },
    onToolbarPreparingMrp (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>주간  자재 소요량</b></div>`
          }
        }
      )
    },
    refreshMrp (from) {
      this.isLoading = true
      this.hideMrpList()
      this.mrpTitle = '주간 다공정품 생산계획-MRP(소요/부족)'
      let param = {
        title: ConstDef.WEEK_PLAN_WIP_KEY,
        fromDate: from,
        toDate: AppLib.calcDateFromToday(13),
        품목유형: ConstDef.다공정품,
        bomOption: 'ALL_NODE'
      }
      const distinctProc = this.$_sp.runNoEncodeFindProc('spFindAllMrpDisPCodeByTitleAndDate', param)
      const mrpProc = this.$_sp.runNoEncodeFindProc('spFindAllWeekMrpByTitleAndDateV2', param)
      axios.all([distinctProc, mrpProc])
        .then(axios.spread((...reponse) => {
          this.isLoading = false
          let goods = this.$_sp.MakeModel(reponse[0])
          let mrp = this.$_sp.MakeModel(reponse[1])
          console.log(goods)
          console.log(mrp)
          if (mrp.length > 0) {
            this.showMrpList()
            this.setInitDataSource(goods, mrp)
          }
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    setInitDataSource (goods, mrp) {
      this.dateArrayMrp = []
      let i = 0
      let day = null
      for (i = 0; i < this.weekDays; i++) {
        day = AppLib.calcDateFromFormat(this.today, i)
        let temp = {
          caption: `${day.substring(5, 7)}/${day.substring(8, 10)}`,
          dataField: `${day.substring(5, 7)}/${day.substring(8, 10)}소요`,
          format: '#,##0',
          dataType: 'number',
          stockField: `${day.substring(5, 7)}/${day.substring(8, 10)}부족`
        }
        this.dateArrayMrp.push(temp)
      }
      this.mrpInfoList = []
      for (i = 0; i < goods.length; i++) {
        let where = this.$_.where(mrp, { 품번: goods[i].품번 })
        where = this.$_.sortBy(where, '소요일자')
        let sum = 0
        let j = 0
        for (j = 0; j < where.length; j++) {
          if (j === 0) {
            goods[i].현재고 = where[j].현재고
            goods[i].현재공 = where[j].현재공
          }
          day = AppLib.formatYMD(where[j].소요일자)
          day = `${day.substring(5, 7)}/${day.substring(8, 10)}`
          let stock = `${day}부족`
          goods[i][`${day}소요`] = Math.round(where[j].소요량 * 100) / 100
          sum = Math.round((sum + where[j].소요량) * 10) / 10
          goods[i][stock] = Math.round(where[j].현재고 + where[j].현재공 - sum)
        }
        goods[i].합계 = sum
      }
      this.mrpDataSource = this.mrpInfoList = goods
      console.log(this.mrpDataSource)
    }
  }
}
</script>

<style lang="scss">
.mrp-wrap {
  margin-top: 10px;
  overflow: hidden;
  display: none;
}
.week-plan {
  tr{
    border-bottom: 1px solid rgb(204, 204, 204);
    height: 27px;
  }
  td{
    border-right: 1px solid rgb(221,221,221);
    padding: 0 6px;
  }
  .row-number-span {
    text-align: right;
  }
  .row-number {
    text-align: right;
    border-left: 0px solid rgb(204, 204, 204);
  }
  .dx-row-minus {
    color: red;
  }

}
.dx-row-toggle {
  background-color: rgb(247, 247, 247);
}
.week-plan:hover {
  background-color: rgb(226, 226, 226);
}
</style>
